// store/modules/user.js
export default {
    // 命名空间（模块化隔离）
    namespaced: true,
    // 状态（对应Pinia的state）
    state: () => ({
        loginFlag: false,
        userInfo: null
    }),
    // 计算属性（对应Pinia的getters）
    getters: {
        getLoginFlag: (state) => state.loginFlag,
        getUserInfo: (state) => state.userInfo
    },
    // 同步修改（对应Pinia的同步actions）
    mutations: {
        SET_LOGIN_FLAG(state, value) {
            state.loginFlag = value
        },
        SET_USER_INFO(state, value) {
            state.userInfo = value
        }
    },
    // 异步/同步操作（若有异步逻辑可放这里，Pinia的异步actions对应此处）
    actions: {
        // 若需要异步修改状态，示例：
        // async setUserInfoAsync({ commit }, value) {
        //   const res = await api.getUserInfo();
        //   commit('SET_USER_INFO', res.data);
        // }
    }
}